import React from 'react';
import { ErrorMessage } from 'formik';
import CurrencyInput from 'components/Input/currencyInput.component';
import Required from '../../../../../components/Required/required.component';
import Input from '../../../../../components/Input/input.component';
import { numberMask } from '../../../../../components/Input/Masks';

const EditarHistoricoCompraEmergencial = (props) => {
	const { handleChange, transacao } = props;

	return (
		<React.Fragment>
			<div className='row'>
				<div className='col-md-12'>
					<label>
						Número da solicitação de empenho: <Required />
					</label>
					<div className='form-group'>
						<Input
							type='input'
							name='destinoEstoque.numero'
							onChange={handleChange}
							value={transacao.destinoEstoque.numero ? transacao.destinoEstoque.numero.replace('/', '') : undefined}
							maxLength='20'
							mask={numberMask}
						/>
						<ErrorMessage
							name='destinoEstoque.numero'
							render={msg => (
								<span className='text-danger'>
									{msg}
								</span>
							)}
						/>
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<label>
						Quantidade: <Required />
					</label>
					<div className='form-group'>
						<Input
							type='text'
							mask={numberMask}
							name='quantidadeEntradaSaida'
							onChange={handleChange}
							value={transacao.quantidadeEntradaSaida}
							maxLength={18}
						/>
						<ErrorMessage
							name='quantidadeEntradaSaida'
							render={msg => (
								<span className='text-danger'>
									{msg}
								</span>
							)}
						/>
					</div>
				</div>
				<div className='col-md-6'>
					<label>
						Valor unitário: <Required />
					</label>
					<div className='form-group'>
						<div className='input-group-prepend'>
							<div className='input-group-text'>R$</div>
							<CurrencyInput
								name='destinoEstoque.valorUnitario'
								value={transacao.destinoEstoque.valorUnitario !== '' ? transacao.destinoEstoque.valorUnitario : null}
								handleChange={handleChange}
								precision='2'
							/>
						</div>
						<ErrorMessage
							name='destinoEstoque.valorUnitario'
							render={msg => (
								<span className='text-danger'>
									{msg}
								</span>
							)}
						/>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default EditarHistoricoCompraEmergencial;
